import React from 'react';

const HelpPage: React.FC = () => {
  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-12">
          <div className="card shadow">
            <div className="card-header bg-warning text-dark">
              <h5><i className="fas fa-question-circle me-2"></i>Centro de Ajuda - FAQ</h5>
            </div>
            <div className="card-body">
              <div className="accordion" id="helpAccordion">
                {/* Como abrir animais */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingAnimals">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAnimals" aria-expanded="false" aria-controls="collapseAnimals">
                      <i className="fas fa-paw me-2"></i>Como adicionar e gerir os meus animais?
                    </button>
                  </h2>
                  <div id="collapseAnimals" className="accordion-collapse collapse" aria-labelledby="headingAnimals" data-bs-parent="#helpAccordion">
                    <div className="accordion-body">
                      <h6><i className="fas fa-plus-circle me-2 text-success"></i>Adicionar um novo animal:</h6>
                      <ol>
                        <li>Clique em <strong>"Meus Animais"</strong> no menu principal</li>
                        <li>Preencha o formulário com:
                          <ul>
                            <li><strong>Nome do Animal:</strong> Nome do seu cão</li>
                            <li><strong>Data de Nascimento:</strong> Data de nascimento do animal</li>
                            <li><strong>Observações:</strong> Informações adicionais (opcional)</li>
                          </ul>
                        </li>
                        <li>Clique em <strong>"Adicionar Animal"</strong></li>
                      </ol>
                      
                      <h6><i className="fas fa-edit me-2 text-primary"></i>Editar um animal:</h6>
                      <ol>
                        <li>Na lista dos seus animais, clique no botão <strong>"Editar"</strong></li>
                        <li>Modifique os dados necessários</li>
                        <li>Clique em <strong>"Guardar"</strong></li>
                      </ol>
                      
                      <h6><i className="fas fa-trash me-2 text-danger"></i>Eliminar um animal:</h6>
                      <ol>
                        <li>Na lista dos seus animais, clique no botão <strong>"Eliminar"</strong></li>
                        <li>Confirme a eliminação</li>
                      </ol>
                      
                      <div className="alert alert-info mt-3">
                        <i className="fas fa-info-circle me-2"></i>
                        <strong>Nota:</strong> Só pode eliminar animais que não tenham marcações ativas.
                      </div>
                    </div>
                  </div>
                </div>

                {/* Como fazer marcações */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingBookings">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBookings" aria-expanded="false" aria-controls="collapseBookings">
                      <i className="fas fa-calendar-check me-2"></i>Como fazer marcações de aulas?
                    </button>
                  </h2>
                  <div id="collapseBookings" className="accordion-collapse collapse" aria-labelledby="headingBookings" data-bs-parent="#helpAccordion">
                    <div className="accordion-body">
                      <h6><i className="fas fa-calendar me-2 text-primary"></i>Ver o calendário:</h6>
                      <ol>
                        <li>Clique em <strong>"Calendário"</strong> no menu principal</li>
                        <li>Selecione a data desejada</li>
                        <li>Escolha entre <strong>"Vista Diária"</strong> ou <strong>"Vista Semanal"</strong></li>
                      </ol>
                      
                      <h6><i className="fas fa-plus me-2 text-success"></i>Fazer uma marcação:</h6>
                      <ol>
                        <li>No calendário, procure por horários disponíveis</li>
                        <li>Clique no horário desejado</li>
                        <li>Selecione o animal que vai participar na aula</li>
                        <li>Clique em <strong>"Marcar"</strong></li>
                      </ol>
                      
                      <h6><i className="fas fa-clock me-2 text-warning"></i>Regras importantes:</h6>
                      <ul>
                        <li>As marcações devem ser feitas com <strong>pelo menos 24 horas de antecedência</strong> (exceto segunda-feira)</li>
                        <li>Só pode marcar para animais que tenha registado no sistema</li>
                        <li>Horários já marcados aparecem em azul e não estão disponíveis</li>
                        <li>Horários bloqueados pelo treinador aparecem em cinza</li>
                      </ul>
                      
                      <h6><i className="fas fa-times me-2 text-danger"></i>Cancelar uma marcação:</h6>
                      <ol>
                        <li>No calendário, encontre a sua marcação (aparece destacada)</li>
                        <li>Clique no botão <strong>"Cancelar"</strong></li>
                        <li>Confirme o cancelamento</li>
                      </ol>
                    </div>
                  </div>
                </div>

                {/* Como ver o tempo */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingWeather">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWeather" aria-expanded="false" aria-controls="collapseWeather">
                      <i className="fas fa-cloud-sun me-2"></i>Como ver a previsão do tempo?
                    </button>
                  </h2>
                  <div id="collapseWeather" className="accordion-collapse collapse" aria-labelledby="headingWeather" data-bs-parent="#helpAccordion">
                    <div className="accordion-body">
                      <h6><i className="fas fa-cloud me-2 text-info"></i>Aceder à previsão:</h6>
                      <ol>
                        <li>Clique em <strong>"Tempo"</strong> no menu principal</li>
                        <li>Veja a previsão atual e para os próximos dias</li>
                        <li>A previsão é atualizada automaticamente</li>
                      </ol>
                      
                      <h6><i className="fas fa-info-circle me-2 text-primary"></i>Informações disponíveis:</h6>
                      <ul>
                        <li><strong>Temperatura:</strong> Temperatura atual e máxima/mínima</li>
                        <li><strong>Condições:</strong> Estado do tempo (sol, chuva, nublado, etc.)</li>
                        <li><strong>Humidade:</strong> Percentagem de humidade no ar</li>
                        <li><strong>Vento:</strong> Velocidade e direção do vento</li>
                        <li><strong>Previsão horária:</strong> Detalhes para cada hora do dia</li>
                      </ul>
                      
                      <div className="alert alert-warning mt-3">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        <strong>Nota:</strong> A previsão do tempo pode ajudar a planear as suas aulas de agility.
                      </div>
                    </div>
                  </div>
                </div>

                {/* Como gerir a conta */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingAccount">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAccount" aria-expanded="false" aria-controls="collapseAccount">
                      <i className="fas fa-wallet me-2"></i>Como gerir a minha conta e pagamentos?
                    </button>
                  </h2>
                  <div id="collapseAccount" className="accordion-collapse collapse" aria-labelledby="headingAccount" data-bs-parent="#helpAccordion">
                    <div className="accordion-body">
                      <h6><i className="fas fa-user me-2 text-primary"></i>Aceder à conta:</h6>
                      <ol>
                        <li>Clique em <strong>"Minha Conta"</strong> no menu principal</li>
                        <li>Veja o histórico dos seus pagamentos</li>
                        <li>Verifique se há pagamentos pendentes</li>
                      </ol>
                      
                      <h6><i className="fas fa-credit-card me-2 text-success"></i>Pagamentos:</h6>
                      <ul>
                        <li>Os pagamentos são gerados automaticamente pelo treinador</li>
                        <li>Receberá um email quando houver um pagamento pendente</li>
                        <li>Pode ver o histórico completo na sua conta</li>
                        <li>Os pagamentos são processados mensalmente</li>
                      </ul>
                      
                      <h6><i className="fas fa-key me-2 text-warning"></i>Alterar password:</h6>
                      <ol>
                        <li>Clique no seu nome no canto superior direito</li>
                        <li>Selecione <strong>"Alterar Password"</strong></li>
                        <li>Introduza a password atual e a nova password</li>
                        <li>Clique em <strong>"Alterar Password"</strong></li>
                      </ol>
                      
                      <h6><i className="fas fa-question-circle me-2 text-info"></i>Recuperar password:</h6>
                      <ol>
                        <li>Na página de login, clique em <strong>"Esqueci a password"</strong></li>
                        <li>Introduza o seu email</li>
                        <li>Receberá uma nova password por email</li>
                      </ol>
                    </div>
                  </div>
                </div>

                {/* Dicas gerais */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTips">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTips" aria-expanded="false" aria-controls="collapseTips">
                      <i className="fas fa-lightbulb me-2"></i>Dicas e informações úteis
                    </button>
                  </h2>
                  <div id="collapseTips" className="accordion-collapse collapse" aria-labelledby="headingTips" data-bs-parent="#helpAccordion">
                    <div className="accordion-body">
                      <h6><i className="fas fa-mobile-alt me-2 text-primary"></i>Usar no telemóvel:</h6>
                      <ul>
                        <li>O sistema funciona perfeitamente em dispositivos móveis</li>
                        <li>Pode adicionar a aplicação à tela inicial do seu telemóvel</li>
                        <li>As notificações aparecem no topo da página</li>
                      </ul>
                      
                      <h6><i className="fas fa-bell me-2 text-warning"></i>Notificações:</h6>
                      <ul>
                        <li>Receberá notificações quando as suas marcações forem confirmadas</li>
                        <li>Alertas sobre pagamentos pendentes aparecem na sua conta</li>
                        <li>Mensagens de erro são mostradas em vermelho</li>
                        <li>Mensagens de sucesso são mostradas em verde</li>
                      </ul>
                      
                      <h6><i className="fas fa-search me-2 text-info"></i>Navegação:</h6>
                      <ul>
                        <li>Use o menu hambúrguer no telemóvel para aceder a todas as opções</li>
                        <li>O centro de ajuda está sempre disponível no menu</li>
                        <li>Pode alternar entre diferentes vistas do calendário</li>
                        <li>Use os filtros para encontrar informações específicas</li>
                      </ul>
                      
                      <div className="alert alert-success mt-3">
                        <i className="fas fa-heart me-2"></i>
                        <strong>Dica:</strong> Mantenha os dados dos seus animais atualizados para facilitar as marcações!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-4 p-3 bg-light rounded">
                <h6><i className="fas fa-envelope me-2"></i>Precisa de mais ajuda?</h6>
                <p className="mb-2">Se não encontrou a resposta que procura, contacte o treinador através dos canais habituais.</p>
                <p className="mb-0 text-muted small">
                  <i className="fas fa-info-circle me-1"></i>
                  Este centro de ajuda é atualizado regularmente com as informações mais recentes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpPage; 